import HTMLReactParser from "html-react-parser"
import React from "react"
import { Fade } from "react-awesome-reveal"

import RichText from "./richText/Parser"

function Slide({ slide }) {
  return (
    <div className="w-[calc(80%_-_1rem)] md:min-w-[540px] md:w-1/2 shrink-0 lg:w-[calc((1200px_-_1.5rem)_/_2)] p-4 bg-greenGrey-100 flex">
      <div className="shrink-0 flex grow flex-col gap-8  w-full">
        <h4 className="text-2xl sm:text-3xl text-white bold">{slide.title}</h4>
        <div className="flex flex-wrap md:flex-nowrap gap-6">
          <div className="md:w-2/5">
            {slide.subtitle ? (
              <p className="font-bold leading-tight	 text-lg text-white">
                {HTMLReactParser(slide.subtitle)}
              </p>
            ) : (
              slide?.media && (
                <div className="grow flex items-end w-full">
                  <Fade>
                    <img
                      srcSet={
                        slide.media?.localFile?.childImageSharp?.gatsbyImageData
                          ?.images?.sources[0]?.srcSet
                      }
                      alt={slide.media.altText}
                      className="max-h-96 mx-auto"
                    />
                  </Fade>
                </div>
              )
            )}
          </div>
          <div className="md:w-3/5 text-gray-500 prose">
            {slide.richContent && (
              <RichText
                stringHtml={slide.richContent}
                option="standardOptions"
                dark
                bigger={false}
              />
            )}
          </div>
        </div>
        {slide.subtitle && slide?.media && (
          <div className="grow flex items-end w-full">
            <Fade>
              <img
                srcSet={
                  slide.media?.localFile?.childImageSharp?.gatsbyImageData
                    ?.images?.sources[0]?.srcSet
                }
                alt={slide.media.altText}
                className="max-h-96 mx-auto"
              />
            </Fade>
          </div>
        )}
      </div>
    </div>
  )
}
export default function SliderBlock({ component }) {
  const { richtitle, slider } = component

  return (
    <div className="relative overflow-hidden bg-charlestonGreen-100 z-10">
      <div className=" py-24 ">
        <div className="lg:mx-auto lg:max-w-7xl sm:px-6 lg:px-8 lg:flex lg:gap-12">
          <div className="w-full mx-auto lg:max-w-none lg:mx-0 lg:px-0 ">
            <div className="">
              <div className="pb-6 px-4 lg:pb-12">
                {richtitle && (
                  <RichText stringHtml={richtitle} option="heroBlueTitle" />
                )}
              </div>
            </div>
          </div>
        </div>
        {slider?.length > 0 && (
          <div>
            <div className="flex gap-4 sm:gap-6 lg:gap-12 overflow-scroll">
              <div className="w-[calc(((100vw_-_1215px)_/_2)_-_3rem)] shrink-0 " />
              {slider.map((s, key) => (
                // eslint-disable-next-line react/no-array-index-key
                <Slide key={key} slide={s} />
              ))}
              <div className="w-[calc(((100vw_-_1215px)_/_2)_-_3rem)] shrink-0 " />
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
